import Vue from 'vue'
import Vuex from 'vuex'
import mutationTypes from './mutation-types.js'
import modules from './modules/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    customerUrl: '',
    isContinueLater: false
  },
  mutations: {
    [mutationTypes.SET_CUSTOMER_URL] (state, url) {
      state.customerUrl = url
    },
    [mutationTypes.SET_IS_CONTINUE_LATER] (state, isContinueLater) {
      state.isContinueLater = isContinueLater
    }
  },
  actions: {
    async updateReturnUrl ({ commit }, url) {
      commit(mutationTypes.SET_CUSTOMER_URL, url)
    },
    async updateIsContinueLater ({ commit }, isContinueLater) {
      commit(mutationTypes.SET_IS_CONTINUE_LATER, isContinueLater)
    }
  },
  modules: {
    namespaced: true,
    ...modules
  },
  getters: {
    getCustomerUrl: state => {
      return state.customerUrl
    },
    getIsContinueLater: state => {
      return state.isContinueLater
    }
  }
})
